import {  GridApi,  GridOptions,  IServerSideDatasource} from "@ag-grid-community/core";
import {  Component, OnInit, Input, OnChanges, SimpleChanges,OnDestroy,} from "@angular/core";
import { SkuDetail } from "src/app/models/priceyard.model";
import { PriceyardService } from "../../../priceyard/services/priceyard.service";
import { DateCellRendererComponent } from "../../../../ag-grid-components/date-cell-renderer/date-cell-renderer.component";
import { LoadingCellRendererComponent } from "../../../../ag-grid-components/loading-cell-renderer/loading-cell-renderer.component";
import { SkuCellRendererComponent } from "../../../../ag-grid-components/sku-cell-renderer/sku-cell-renderer.component";
import { HeaderService } from "../../../../components/header/header.service";
import { SellerCellRendererComponent } from "src/app/ag-grid-components/seller-cell-renderer/seller-cell-renderer.component";
import { Subject, takeUntil } from "rxjs";
import { SettingsService } from "src/app/services/settings.service";

@Component({
  selector: "app-sku-competition-grid",
  templateUrl: "./sku-competition-grid.component.html",
  styleUrls: ["./sku-competition-grid.component.scss", "../mini-grid.scss"],
})
export class SkuCompetitionGridComponent implements OnInit, OnChanges,OnDestroy {
  @Input() sku: SkuDetail;
  gridApi: GridApi;
  skuId: string;
  accounts;
  marketPlace: string;
  private destroy$ = new Subject<void>();
  columnDefs: any = [
    {
      field: "Seller",
      minWidth: 130,
      cellClass: params => {
        return params.data.IsMe? 'seller-Exists' : null;
      },
      cellRenderer: "sellerCellRendererComponent",
    },
    {
      field: "Price",
      headerName:"Price",
      minWidth: 70,
      maxWidth: 150,
      sort: "asc",
      sortable:true,
      valueFormatter: (params) =>
        this.priceyardService.currencyFormatter(params.data.Price, "$"),
    },
    {
      field: "BB",
      minWidth: 35,
      maxWidth: 100,
      cellClass: 'input-col',
      cellRenderer: (params) => {
        return `<input type='checkbox' ${
          params.value ? "checked" : ""
        } disabled/>`;
      },
    },
  ];
  walMartColumn = [
    {
      field: "Shipping",
      minWidth: 35,
      maxWidth: 100,
      cellClass: 'input-col',
      cellRenderer: (params) => {
        return `<input type='checkbox' ${
          params.value ? "checked" : ""
        } disabled/>`;
      },
    },
  ];
  amazonColumn = [
    {
      field: "FulfillmentType",
      headerName: 'Fba',
      minWidth: 35,
      maxWidth: 100,
      cellClass: 'input-col',
      cellRenderer: (params) => {
        return `<input type='checkbox' ${
          params.value == 'fba' ? "checked" : ""
        } disabled/>`;
      },
    },
    {
      field: "Prime",
      minWidth: 35,
      maxWidth: 100,
      cellClass: 'input-col',
      cellRenderer: (params) => {
        return `<input type='checkbox' ${
          params.value ? "checked" : ""
        } disabled/>`;
      },
    },
  ];
  components = {
    loadingCellRenderer: LoadingCellRendererComponent,
    dateCellRendererComponent: DateCellRendererComponent,
    skuCellRendererComponent: SkuCellRendererComponent,
    sellerCellRendererComponent: SellerCellRendererComponent
  };
  gridOptions: GridOptions = {
    rowModelType: "serverSide",
    suppressServerSideInfiniteScroll: false,
    suppressCopyRowsToClipboard: true,
    cacheBlockSize: 100,
    defaultColDef: {
      resizable: true,
      sortable:false,
      filterParams: {
        maxNumConditions : 1,
      },
      menuTabs: ["filterMenuTab"],
    },
    columnDefs: this.columnDefs,
    components: this.components,
    rowSelection: "multiple",
    loadingCellRenderer: "loadingCellRenderer",
    onGridReady: (e) => {
      this.gridApi = e.api;
      this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => {
        this.gridApi.showLoadingOverlay();
        this.checkAccountType();
      });
    },
    onGridSizeChanged: (e) => this.resized(),
  };
  dataSource: IServerSideDatasource = {
    getRows: (params: any) => {
      if (this.sku.sku) {
        this.priceyardService
          .CompetitionListDetail(params.request, this.columnDefs, [{
            field: "Sku",
            filter: this.sku?.sku,
          },{
            field: "MarketPlace",
            filter: this.marketPlace,
          }]).pipe(takeUntil(this.destroy$)).subscribe({
            next: (response: any) => {
              if (response) {
                if (!response.totalCount) {
                  this.gridApi.showNoRowsOverlay();
                } else {
                  this.gridApi.hideOverlay();
                }
                params.success({
                  rowData: response.data,
                  rowCount: response.totalCount,
                });
              }
            },
           error: (err) => {
            params.fail()
         }
       });
      }
    },
  };
  isSidePanel: boolean;

  constructor(
    private priceyardService: PriceyardService,
    private headerService: HeaderService,
    private settingsService: SettingsService,
  ) {    
    this.headerService.amazonRegionId.subscribe((res)=>{
      this.marketPlace = res;
    }),
    this.isSidePanel = localStorage.getItem("toolPanel") === "true";
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.sku && this.sku.sku && this.sku.sku !== this.skuId && this.skuId) {
      this.checkAccountType();
    }

  }

  checkAccountType() {
    if (this.sku) {
      this.skuId = this.sku.sku;
      let columnDefs = [];
      if (this.sku && this.sku.accountType === "Amazon") {
        columnDefs = [...this.columnDefs, ...this.amazonColumn];
      } else if (this.sku.accountType === "Walmart") {
        columnDefs = [...this.columnDefs, ...this.walMartColumn];
      }
      this.setGrid(columnDefs);
    }
  } 

  setGrid(columnDefs) {
    this.gridApi.setGridOption('columnDefs', columnDefs);
    this.gridApi.setGridOption("serverSideDatasource", this.dataSource);
    this.resized();
  }

  resized() {
    this.gridApi.sizeColumnsToFit();
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
 }
